import { render, staticRenderFns } from "./SalaryReportIndex.vue?vue&type=template&id=89578cca&scoped=true"
import script from "./SalaryReportIndex.vue?vue&type=script&lang=js"
export * from "./SalaryReportIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89578cca",
  null
  
)

export default component.exports